// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@37signals/lexxy"
import "@rails/activestorage"
import "./controllers"

const pwaEnabled = document.querySelector('meta[name="pwa-enabled"][content="1"]')
if (pwaEnabled && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker", { scope: "/" })
}
